export class PriLabelModel{
    columns:string[];
    rows:any[];

    constructor(){}
}